import { Component, effect, inject, input } from '@angular/core';
import { type Country, DEFAULT_COUNTRY, PhoneNumberClass } from '@core';
import { type ChildClient } from '@models';
import { Store } from '@ngrx/store';
import { ClientManagementActions } from '@ngrx-store';
import { CountrySelectComponent, InlineInputComponent } from '@ui';

@Component({
  imports: [InlineInputComponent, CountrySelectComponent],
  selector: 'avs-phone-number',
  standalone: true,
  templateUrl: './phone-number.component.html',
})
export class PhoneNumberComponent extends PhoneNumberClass {
  client = input.required<ChildClient>();
  disabled = input(false);

  protected readonly DEFAULT_COUNTRY = DEFAULT_COUNTRY;
  private store = inject(Store);

  constructor() {
    super();

    effect(() => {
      this.setMaskByCountryCode(this.client().tags['countryCode'] || DEFAULT_COUNTRY.code);
    });
  }

  protected onUpdate(fieldData: Record<string, string>) {
    const client = this.client();

    this.store.dispatch(
      ClientManagementActions.updateChildClient({
        clientClientId: client.id,
        clientData: { tags: { ...client.tags, ...fieldData } },
      }),
    );
  }

  protected onCountryCodeChange(country: Country) {
    const client = this.client();

    this.store.dispatch(
      ClientManagementActions.updateChildClient({
        clientClientId: client.id,
        clientData: {
          tags: {
            countryCode: country.code,
            phoneCode: country.phoneCode,
          },
        },
      }),
    );
  }
}
